<div class="inline-block tag-button-container" data-testid="tag-button-container">
  <button
    class="tag-button ps-xsmall-x"
    [class.tag-default]="theme === ChipTheme.DEFAULT"
    [class.tag-active]="theme === ChipTheme.ACTIVE"
    [class.tag-popular]="theme === ChipTheme.POPULAR"
    [class.tag-light]="theme === ChipTheme.LIGHT"
    [attr.aria-label]="title"
    [attr.title]="title"
    [disabled]="disabled"
    (blur)="blur.emit($event)"
    (click)="tagClicked.emit($event)"
  >
    <ng-content *ngIf="!text" />
    <span *ngIf="text" class="ps-xxsmall-y flex flex--center">
      <span class="font-body-1 regular-type">{{ text }}</span>
      <fcom-icon *ngIf="iconName" [category]="iconCategory" [name]="iconName" class="icon-small ps-xxsmall-l" />
    </span>
  </button>
</div>
